import {
    all,
    call,
    fork,
    put,
    takeEvery
} from "redux-saga/effects";
import apiAuth from "../../helpers/ApiAuth";
import {
    GET_TODAY_COUNT_LOG,
    GET_TODAY_COUNT_LOG_ERROR,
    GET_TODAY_COUNT_LOG_SUCCESS
} from "./actions";
import { reMapGetCountData } from "./normalizer"
import moment from 'moment'

export function* watchGetCountLog() {
    yield takeEvery(GET_TODAY_COUNT_LOG, getCountLogData);
}

const getCountLogDataAsync = async () => await apiAuth.get("api/log/people_count/", { params: { start_date: moment().format("YYYY-MM-DD"), end_date: moment().add(1, 'days').format("YYYY-MM-DD") } }).then(facilities => facilities.data).catch(error => {
    if (error.response.status === 401) {
        return { message: "Incorrect Credentials" };
    }
    return { message: error };
});

function* getCountLogData() {

    try {
        const counts = yield call(getCountLogDataAsync);

        if (!counts.message) {
            const payload = reMapGetCountData(counts)
            yield put({ type: GET_TODAY_COUNT_LOG_SUCCESS, payload: payload });
        } else {
            yield put({ type: GET_TODAY_COUNT_LOG_ERROR, payload: counts.message });
        }
    } catch (error) {
        yield put({ type: GET_TODAY_COUNT_LOG_ERROR, payload: error });
    }
}




export default function* rootSaga() {
    yield all([fork(watchGetCountLog)]);
}
